import { Config as ConfigType } from './types';
import { user } from './sytria/user';
import { expert } from './sytria/expert';
import { client } from './sytria/client';
import { company } from './sytria/company';
import { mission } from './sytria/mission';
import { invitation } from './sytria/invitation';
import { candidate } from './sytria/candidate';
import { candidacy } from './sytria/candidacy';
import { proposal } from './sytria/proposal';
import { quotation } from './sytria/quotation';
import { charge } from './sytria/charge';
import { milestone } from './sytria/milestone';
import { contract } from './sytria/contract';
import { contractMilestone } from './sytria/contractMilestone';
import { invoice } from './sytria/invoice';
import { recommendation } from './sytria/recommendation';
import { legalInformation } from './sytria/legalInformation';
import { cgu } from './sytria/cgu';
import { match } from './sytria/match';
import { document } from './sytria/document';
import { subCategory } from './sytria/subCategory';
import { documentFile } from './sytria/documentFile';
import { documentsCompanies } from './sytria/documentsCompanies';
import { tag } from './sytria/tag';
import { clientInvoice } from './sytria/clientInvoice';
import { expertInvoice } from './sytria/expertInvoice';
import { payments } from './sytria/payments';
import { creditNotes } from './sytria/creditNote';

export const config: ConfigType = {
  login: 'password',
  hash: '4rr0tdosatvzb70almrhxtkbk',
  locale: 'fr',
  name: 'sytria',
  dashboard: false,
  theme: {
    primary: '#172844',
    secondary: '#172844',
    tertiary: '#f28a0b',
    disabled: '#1daec5',
    info: '#172844',
    alert: '#dd1d1e',
    success: '#90b524',
    cancel: '#8a8f94',
  },
  defaultCountry: 'fr',
  preferredCountries: ['fr', 'ma', 'ch', 'tn'],
  invoiceUploadedByUser: true,
  resources: [
    expert,
    client,
    user,
    subCategory,
    company,
    mission,
    invitation,
    candidate,
    candidacy,
    proposal,
    quotation,
    charge,
    milestone,
    contract,
    contractMilestone,
    invoice,
    creditNotes,
    recommendation,
    legalInformation,
    document,
    documentFile,
    documentsCompanies,
    cgu,
    match,
    tag,
    expertInvoice,
    clientInvoice,
    payments,
  ],
};

export default config;
